import { useCallback } from 'react';

import useEnv from '@zenbusiness/application-commons-env';

import useLoadScriptStatus from '#client/hooks/useLoadScript';

import { VGS_URL } from '../constants/urls';

export default function useInitVGSShow() {
  const { VGS_COLLECT_UNIT_VAULT_ID } = useEnv();

  const scriptStatus = useLoadScriptStatus(VGS_URL);
  const createVGSShow = useCallback(
    async () => window.VGSShow.create(VGS_COLLECT_UNIT_VAULT_ID, () => {}),
    [VGS_COLLECT_UNIT_VAULT_ID]
  );

  return {
    createVGSShow,
    scriptStatus
  };
}
